import React, {forwardRef, useState} from 'react';

import Icon from './icon';
import K from '../k';

const CollapsibleHeader = forwardRef(function Component({header, headerStyle, type = 'h3', collapsed, defaultCollapsed = false, right = true, expandIcon, onChange, style, children, contentStyle}, ref) {
  //HINT determines whether or not component should be managed locally.
  //     When isControlled is true, behavior is only driven by props.
  const isControlled = typeof collapsed === 'boolean';
  const [isCollapsed, setIsCollapsed] = isControlled ? [collapsed, null] : useState(defaultCollapsed);

  const styles = {
    container: {...style},
    headerContainer: {display: 'flex', alignItems: 'center', ...headerStyle},
    header: {margin: 0},
    icon: {
      transform: isCollapsed ? !right ? 'rotate(90deg)' : 'rotate(270deg)' : 'rotate(180deg)',
      margin: `0 ${!right ? K.spacing : '0'}px 0 ${right ? K.spacing : '0'}px`,
    },
    content: {display: 'flex', flexWrap: 'wrap', ...contentStyle}
  };

  const HeadingTag = type;

  const handleClick = () => {
    if (!isControlled) setIsCollapsed(!isCollapsed);

    if (onChange) onChange(!isCollapsed);
  };

  return (
    <div {...{ref}} style={styles.container}>
      <div onClick={handleClick} style={styles.headerContainer}>
        {!right && <Icon icon={expandIcon} name='upArrow' style={styles.icon}/>}
        <HeadingTag style={styles.header}>{header}</HeadingTag>
        {right && <Icon icon={expandIcon} name='upArrow' style={styles.icon}/>}
      </div>
      <div style={styles.content}>
        {isCollapsed ? null : children}
      </div>
    </div>
  );
});

export default CollapsibleHeader;